package com.macrofocus.eflux.ui.perspective

import com.macrofocus.eflux.DataLoader
import com.macrofocus.eflux.components.blurBackground
import com.macrofocus.eflux.ui.perspective.layers.LayerSwitch
import i18next.invoke
import i18next.useTranslation
import js.objects.unsafeJso
import mui.material.Paper
import mui.material.styles.Theme
import mui.material.styles.useTheme
import mui.system.SxProps
import org.mkui.component.CPComponent
import org.mkui.react.useProperty
import react.FC
import react.Props
import web.cssom.Overflow
import web.cssom.Position
import web.cssom.pct
import web.cssom.px

class LayersPerspective(private val dataLoader: DataLoader) : CPComponent {
    override val nativeComponent: FC<*> = FC<Props> {
        val theme = useTheme<Theme>()
        val (t, _) = useTranslation()

        val (expertMode, _) = useProperty(dataLoader.exportMode)

        val customBackground: (SxProps<Theme>) -> Unit = { it ->
            it.blurBackground(theme)
        }

        Paper {
            sx = unsafeJso {
                position = Position.absolute
                top = 0.px
//                bottom = 0.px
                maxHeight = 100.pct
                left = 0.px
                right = 0.px
                overflowY = Overflow.scroll

                customBackground(this)
            }


            if (expertMode) {
                LayerSwitch {
                    label = t("appMenu.configuration.cities.label")
                    property = dataLoader.cities
                }
            }

            LayerSwitch {
                label = t("appMenu.configuration.nodes.labels")
                property = dataLoader.labelSubstations
            }

            LayerSwitch {
                label = "Schemas"
                property = dataLoader.schemas
            }
        }
    }
}